import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  error: false,
  currentPage: "1",
  matches: [],
  hasNext: true,
  totalPage: 0,
  loading: true,
  success: false,
  currentFavMatchId: "",
  isEmpty: false
};

const TopMatchesSlice = createSlice({
  name: "topMatches",
  initialState,
  reducers: {
    getTopMatchesStart: (state, action) => {
      state.loading = action?.payload?.loadingFalse ? false : true;
      state.error = false;
      state.success = false;
    },
    getTopMatchesSuccess: (state, action) => {
      let currentPage = parseInt(action?.payload?.data?.currentPage);
      let totalPage = parseInt(action?.payload?.data?.totalPage);
      const matches = action?.payload?.data?.matchList?.map((match) => {
        const matchMarkets = {};
        const matchMarketIds = match?.matchMarkets?.map((market) => {
          matchMarkets[market?.matchMarketId] = market;

          return market?.matchMarketId;
        });
        return {
          ...match,
          matchMarkets,
          matchMarketIds
        };
      });

      state.currentPage = currentPage;
      state.hasNext = currentPage < totalPage;
      state.totalPage = totalPage;
      state.loading = false;
      state.success = true;
      state.isEmpty = !action?.payload?.data?.matchList?.length;
      if (action?.payload?.isHome) {
        state.matches.push(...matches);
      } else {
        state.matches = matches;
      }
    },
    getTopMatchesFailure: (state) => {
      state.loading = false;
      state.error = true;
      state.loading = false;
      state.error = true;
      state.isEmpty = false;
    },

    resetTopMatches: (state) => {
      state.currentPage = "1";
      state.matches = [];
      state.hasNext = false;
      state.totalPage = 0;
      state.isEmpty = false;
    }
  }
});

export const {
  getTopMatchesStart,
  getTopMatchesSuccess,
  getTopMatchesFailure,
  resetTopMatches
} = TopMatchesSlice.actions;

export default TopMatchesSlice.reducer;
